import React from 'react';

import { useMediaQuery } from 'ha/helpers/MediaQuery';

import NavBarDesktop from '../containers/NavBarDesktop.lazy';
import NavBarMobile from '../containers/NavBarMobile.lazy';

interface Props {
  hasStickyNav?: boolean;
  showMiddleMenu?: boolean;
  showSearchBar?: boolean;
  searchBarElement?: React.ReactNode;
  advertiserLogo?: string;
  showActions?: boolean;
  showLogo?: boolean;
  showMobileDrawerMenu?: boolean;
}

export const NavBar: React.FC<Props> = ({
  hasStickyNav,
  showMiddleMenu,
  showSearchBar,
  searchBarElement,
  advertiserLogo,
  showActions,
  showLogo,
  showMobileDrawerMenu,
}) => {
  const { md } = useMediaQuery();

  return md ? (
    <NavBarDesktop
      hasStickyNav={hasStickyNav}
      showMiddleMenu={showMiddleMenu}
      showSearchBar={showSearchBar}
      searchBarElement={searchBarElement}
      advertiserLogo={advertiserLogo}
      showActions={showActions}
      showLogo={showLogo}
    />
  ) : (
    <NavBarMobile
      showSearchBar={showSearchBar}
      searchBarElement={searchBarElement}
      showMobileDrawerMenu={showMobileDrawerMenu}
      showLogo={showLogo}
      advertiserLogo={advertiserLogo}
    />
  );
};

export default NavBar;
